module.exports = __webpack_public_path__ + "img/mobile-banner3-th.1469bb29.jpg";